import { Paper, Stack, Typography, Box, Grid } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const MissingTariffAlert = ({
    startMunicipality,
    endMunicipality,
    division,
    tonnage,
    routeType
}) => {
    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            
            <Grid item xs={12} md={6}>
                <Paper
                    elevation={0}
                    sx={{
                        p: 3,
                        borderRadius: 3,
                        backgroundColor: "#FFF8E1",
                        border: "1px solid #FFE0B2",
                        height: "100%"
                    }}
                >
                    <Stack spacing={2} alignItems="center">
                        <WarningAmberRoundedIcon
                            sx={{ fontSize: 46, color: "#ED6C02" }}
                        />

                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Tarifario requerido
                        </Typography>

                        <Box sx={{ width: "70%" }}>
                            <Grid container spacing={2}>
                                <Item title="Municipio inicio" value={startMunicipality} />
                                <Item title="Municipio fin" value={endMunicipality} />
                                <Item title="División" value={division} />
                                <Item title="Tonelaje" value={tonnage} />
                                <Item title="Tipo de ruta" value={routeType} full />
                            </Grid>
                        </Box>
                    </Stack>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
    <Paper
        elevation={0}
        sx={{
            p: 3,
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            height: "100%"
        }}
    >
        <Stack spacing={2} alignItems="center" textAlign="center">
            
            {/* ICONO */}
            <InfoOutlinedIcon
                sx={{
                    fontSize: 42,
                    color: "warning.main",
                    opacity: 0.9
                }}
            />

            {/* TITULO CENTRADO */}
            <Typography
                variant="h6"
                sx={{ fontWeight: 600 }}
            >
                Acción requerida
            </Typography>

            {/* MENSAJES */}
            <Typography variant="body2" color="text.secondary">
                Necesitas registrar un tarifario para poder visualizar la ruta.
            </Typography>

            <Typography variant="body2" color="text.secondary">
                Verifica que exista una configuración de tarifario con los
                parámetros mostrados.
            </Typography>
        </Stack>
    </Paper>
</Grid>

        </Grid>
    );
};

const Item = ({ title, value, full }) => (
    <Grid item xs={12} sm={6} md={full ? 12 : 6}>
        <Stack spacing={0.3} alignItems="center">
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{ textAlign: "center" }}
            >
                {title}
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    fontWeight: 600,
                    textAlign: "center"
                }}
            >
                {value}
            </Typography>
        </Stack>
    </Grid>
);


export default MissingTariffAlert;
